import React, { useState } from 'react';
import classnames from 'classnames/bind';
import { Replacement } from '../../../interface';
import style from './index.module.scss';
import localesReplacement from '../../../utils/localesReplacement';
import { useMediaQuery } from 'react-responsive';
import ClickOut from 'react-click-out';

const cx = classnames.bind(style);

interface Props {
  replacements: Replacement;
  selectedIndex?: boolean;
  setSelectedIndex: (v: boolean) => void;
}

const isUK = () => {
  return window.location.href.includes("/en_gb/united-kingdom/");
};

function OwnerSelector(props: Props) {
  const { selectedIndex, setSelectedIndex, replacements } = props;
  const isDesktopOrLaptop = useMediaQuery({ minWidth: 1024 });
  const [visible, setVisible] = useState<boolean>(false);
  const showTooltip = () => {
    if (!isDesktopOrLaptop) {
      setVisible(true);
    }
  };

  const retailText = isUK() ? 'Are you a Vehicle Owner?' : 'Switch to retail';
  const tradeText = isUK() ? 'Are you a Workshop Owner?' : 'Switch to trade';
  const retailModeText = isUK() ? 'Vehicle Owner' : 'You are in retail mode';
  const tradeModeText = isUK() ? 'Workshop Owner' : 'You are in trade mode';

  return (
    <div className={cx('owner-selector')}>
      <div className={cx('roles-switch')}>
        {!selectedIndex ? (
          <div className={cx('role', 'retail')}>
            <div className={cx('text')}>
              <div className={cx('tip')}>
                {localesReplacement(replacements, retailModeText)}
                <ClickOut
                  className='click-out'
                  onClickOut={() => setVisible(false)}
                >
                  <i onClick={showTooltip}>
                    <span className={cx('tooltip', { on: visible })}>
                      {localesReplacement(
                        replacements,
                        'Products recommended are available in consumer pack sizes (below 20L).',
                      )}
                    </span>
                  </i>
                </ClickOut>
              </div>
            </div>
            <span
              className={cx('switch')}
              onClick={() => setSelectedIndex(!selectedIndex)}
            >
              {localesReplacement(replacements, tradeText)}
            </span>
          </div>
        ) : (
          <div className={cx('role', 'trade')}>
            <div className={cx('text')}>
              <div className={cx('tip')}>
                {localesReplacement(replacements, tradeModeText)}
                <ClickOut
                  className='click-out'
                  onClickOut={() => setVisible(false)}
                >
                  <i onClick={showTooltip}>
                    <span className={cx('tooltip', { on: visible })}>
                      {localesReplacement(
                        replacements,
                        'Products recommended may only be available in trade/workshop pack sizes (20L and above).',
                      )}
                    </span>
                  </i>
                </ClickOut>
              </div>
            </div>
            <span
              className={cx('switch')}
              onClick={() => setSelectedIndex(!selectedIndex)}
            >
              <p>{localesReplacement(replacements, retailText)}</p>
            </span>
          </div>
        )}
      </div>
    </div>
  );
}

export default OwnerSelector;
